import EVENTS from "./events.js";
import loadHandlerManager from "./customEvent";
import triggerEvent from "./triggerEvent";
import Messages from "./Messages.js";
const CustomEvent = {
  triggerEvent,
  EVENTS,
  Messages,
  loadHandlerManager
};

export default CustomEvent;
